import { Phone, Clock, MapPin } from "lucide-react";
import { SITE, waLink } from "../data/site";
import { useT } from "../i18n/LanguageContext";

export const Booking = () => {
  const { t } = useT();
  return (
    <section id="prenota" data-testid="booking-section" className="py-24 md:py-32 bg-[var(--espresso)] text-[var(--ivory)] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none opacity-30">
        <div className="absolute top-10 left-10 w-32 h-px bg-[var(--gold)]" />
        <div className="absolute top-10 left-10 w-px h-32 bg-[var(--gold)]" />
        <div className="absolute bottom-10 right-10 w-32 h-px bg-[var(--gold)]" />
        <div className="absolute bottom-10 right-10 w-px h-32 bg-[var(--gold)]" />
      </div>

      <div className="max-w-5xl mx-auto px-5 md:px-10 text-center relative">
        <div className="gold-divider justify-center">
          <span className="line" />
          <span className="text-[11px] tracking-[0.3em] uppercase text-[var(--gold-soft)]">{t("booking.kicker")}</span>
          <span className="line" />
        </div>
        <h2 className="mt-6 font-display text-5xl md:text-7xl tracking-tight-elegant">
          {t("booking.titlePre")} <span className="italic font-serif-elegant text-[var(--gold-soft)]">{t("booking.titleEm")}</span>
        </h2>
        <p className="mt-6 max-w-2xl mx-auto text-[var(--gold-soft)] leading-relaxed font-normal text-lg">{t("booking.desc")}</p>

        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <a
            href={waLink(t("waMessages.book"))}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="booking-cta-whatsapp"
            className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1eb858] text-white px-8 py-4 rounded-full font-semibold uppercase tracking-[0.05em] text-sm transition-all hover:-translate-y-0.5 shadow-[0_10px_28px_rgba(37,211,102,0.35)]"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg>
            {t("booking.ctaWa")}
          </a>
          <a
            href={`tel:${SITE.phoneIntl}`}
            data-testid="booking-cta-phone"
            className="inline-flex items-center gap-3 border border-[var(--gold-soft)]/60 hover:border-[var(--gold-soft)] text-[var(--ivory)] px-8 py-4 rounded-full font-semibold uppercase tracking-[0.05em] text-sm transition-all"
          >
            <Phone className="w-4 h-4" /> {SITE.phone}
          </a>
        </div>

        <div className="mt-14 grid sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
          <InfoBlock icon={<Clock />} title={t("booking.info.hours")} lines={[t("booking.info.lunch"), t("booking.info.dinner"), t("booking.info.closed")]} />
          <InfoBlock icon={<MapPin />} title={t("booking.info.address")} lines={[SITE.address, SITE.city]} />
          <InfoBlock icon={<Phone />} title={t("booking.info.phone")} lines={[SITE.phone, t("booking.info.phoneSub")]} />
        </div>
      </div>
    </section>
  );
};

const InfoBlock = ({ icon, title, lines }) => (
  <div className="border-t border-[var(--gold-soft)]/30 pt-5 text-left">
    <div className="text-[var(--gold-soft)] mb-3">{icon}</div>
    <div className="text-[10px] uppercase tracking-[0.3em] text-[var(--gold-soft)]/80 mb-2">{title}</div>
    {lines.map((l, i) => (
      <div key={i} className={i === 0 ? "font-display text-lg" : "text-sm text-[var(--gold-soft)]/80"}>{l}</div>
    ))}
  </div>
);
